import React from 'react';

const FeeCalculatorFootnotes = ({ footnotes, onChange, onAdd, onRemove }) => {
  const handleChange = (index, field, value) => {
    const updated = [...footnotes];
    updated[index] = { ...updated[index], [field]: value };
    onChange(updated);
  };

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="text-uppercase text-muted mb-0">Legend / Footnotes</h6>
        <button className="btn btn-sm btn-outline-primary" onClick={onAdd}>
          + Add Footnote
        </button>
      </div>

      {footnotes.map((fn, index) => (
        <div key={fn.id || `new-${index}`} className="card mb-2">
          <div className="card-body py-2 px-3">
            <div className="row g-2 align-items-start">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={fn.term}
                  onChange={(e) => handleChange(index, 'term', e.target.value)}
                  placeholder="Term"
                />
              </div>
              <div className="col-md-8">
                <textarea
                  className="form-control form-control-sm"
                  value={fn.definition}
                  onChange={(e) => handleChange(index, 'definition', e.target.value)}
                  rows={2}
                  placeholder="Definition"
                />
              </div>
              <div className="col-md-1 text-end">
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onRemove(index)}
                  title="Remove footnote"
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}

      {footnotes.length === 0 && (
        <p className="text-muted small">No footnotes.</p>
      )}
    </div>
  );
};

export default FeeCalculatorFootnotes;
